import { IModuleDuration } from 'app/library/module/interfaces/module-duration.interface';
import * as momentImported from 'moment';
import { ICreateCourseOfferingExecutionActionPayload } from '../interfaces/create-course-offering-execution.action.payload.interface';
const moment = momentImported;

export class CourseOfferingExecutionCommand {
    name: string;
    start_date: string;
    end_date: string;
    expected_duration: number;
    duration: IModuleDuration;
    course_offering: { id: number };
    version: string;

    constructor(tempExecution: ICreateCourseOfferingExecutionActionPayload) {
        this.name = tempExecution.name;
        this.start_date = tempExecution.startDate ? (moment.isMoment(tempExecution.startDate) ? tempExecution.startDate.format() : moment(tempExecution.startDate).format()) : null;
        this.end_date = tempExecution.endDate ? (moment.isMoment(tempExecution.endDate) ? tempExecution.endDate.format() : moment(tempExecution.endDate).format()) : null;
        this.expected_duration = tempExecution.duration;
        this.duration = tempExecution.digicompDuration;
        this.version = tempExecution.version;
        this.course_offering = { id: Number(tempExecution.courseOfferingId) };
    }
}
